export default __webpack_public_path__ + "static/media/Logo.61dedfce.png";